function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import morphdom from "morphdom";
var name = "cable_ready";
var version = "5.0.6";
var description = "CableReady helps you create great real-time user experiences by making it simple to trigger client-side DOM changes from server-side Ruby.";
var keywords = ["ruby", "rails", "websockets", "actioncable", "cable", "ssr", "stimulus_reflex", "client-side", "dom"];
var homepage = "https://cableready.stimulusreflex.com";
var bugs = "https://github.com/stimulusreflex/cable_ready/issues";
var repository = "https://github.com/stimulusreflex/cable_ready";
var license = "MIT";
var author = "Nathan Hopkins <natehop@gmail.com>";
var contributors = ["Andrew Mason <andrewmcodes@protonmail.com>", "Julian Rubisch <julian@julianrubisch.at>", "Marco Roth <marco.roth@intergga.ch>", "Nathan Hopkins <natehop@gmail.com>"];
var main = "./dist/cable_ready.js";
var module = "./dist/cable_ready.js";
var browser = "./dist/cable_ready.js";
var unpkg = "./dist/cable_ready.umd.js";
var umd = "./dist/cable_ready.umd.js";
var files = ["dist/*", "javascript/*"];
var scripts = {
  lint: "yarn run format --check",
  format: "yarn run prettier-standard ./javascript/**/*.js rollup.config.mjs",
  build: "yarn rollup -c",
  watch: "yarn rollup -wc",
  test: "web-test-runner javascript/test/**/*.test.js",
  "docs:dev": "vitepress dev docs",
  "docs:build": "vitepress build docs && cp ./docs/_redirects ./docs/.vitepress/dist",
  "docs:preview": "vitepress preview docs"
};
var dependencies = {
  morphdom: "2.6.1"
};
var devDependencies = {
  "@open-wc/testing": "^4.0.0",
  "@rollup/plugin-json": "^6.1.0",
  "@rollup/plugin-node-resolve": "^15.3.0",
  "@rollup/plugin-terser": "^0.4.4",
  "@web/dev-server-esbuild": "^1.0.3",
  "@web/dev-server-rollup": "^0.6.4",
  "@web/test-runner": "^0.19.0",
  "prettier-standard": "^16.4.1",
  rollup: "^4.25.0",
  sinon: "^19.0.2",
  vite: "^5.4.10",
  vitepress: "^1.5.0",
  "vitepress-plugin-search": "^1.0.4-alpha.22"
};
var packageInfo = {
  name: name,
  version: version,
  description: description,
  keywords: keywords,
  homepage: homepage,
  bugs: bugs,
  repository: repository,
  license: license,
  author: author,
  contributors: contributors,
  main: main,
  module: module,
  browser: browser,
  import: "./dist/cable_ready.js",
  unpkg: unpkg,
  umd: umd,
  files: files,
  scripts: scripts,
  dependencies: dependencies,
  devDependencies: devDependencies
};
var inputTags = {
  INPUT: true,
  TEXTAREA: true,
  SELECT: true
};
var mutableTags = {
  INPUT: true,
  TEXTAREA: true,
  OPTION: true
};
var textInputTypes = {
  "datetime-local": true,
  "select-multiple": true,
  "select-one": true,
  color: true,
  date: true,
  datetime: true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  textarea: true,
  time: true,
  url: true,
  week: true
};
var activeElement;
var ActiveElement = {
  get element() {
    return activeElement;
  },
  set: function set(element) {
    activeElement = element;
  }
};

// Indicates if the passed element is considered a text input.

var isTextInput = function isTextInput(element) {
  return inputTags[element.tagName] && textInputTypes[element.type];
};

// Assigns focus to the appropriate element... preferring the explicitly passed selector

// * selector - a CSS selector for the element that should have focus

var assignFocus = function assignFocus(selector) {
  var element = selector && selector.nodeType === Node.ELEMENT_NODE ? selector : document.querySelector(selector);
  var focusElement = element || ActiveElement.element;
  if (focusElement && focusElement.focus) focusElement.focus();
};

// Dispatches an event on the passed element

// * element - the element
// * name - the name of the event
// * detail - the event detail

var dispatch = function dispatch(element, name) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var init = {
    bubbles: true,
    cancelable: true,
    detail: detail
  };
  var event = new CustomEvent(name, init);
  element.dispatchEvent(event);
  if (window.jQuery) window.jQuery(element).trigger(name, detail);
};

// Accepts an xPath query and returns the element found at that position in the DOM

var xpathToElement = function xpathToElement(xpath) {
  return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
};

// Accepts an xPath query and returns all matching elements in the DOM

var xpathToElementArray = function xpathToElementArray(xpath) {
  var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var snapshotList = document.evaluate(xpath, document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
  var snapshots = [];
  for (var i = 0; i < snapshotList.snapshotLength; i++) {
    snapshots.push(snapshotList.snapshotItem(i));
  }
  return reverse ? snapshots.reverse() : snapshots;
};

// Return an array with the class names to be used

// * names - could be a string or an array of strings for multiple classes.

var getClassNames = function getClassNames(names) {
  return Array.from(names).flat();
}
// Perform operation for either the first or all of the elements returned by CSS selector

// * operation - the instruction payload from perform
// * callback - the operation function to run for each element
;

var processElements = function processElements(operation, callback) {
  Array.from(operation.selectAll ? operation.element : [operation.element]).forEach(callback);
};

// convert string to kebab-case
// most other implementations (lodash) are focused on camelCase to kebab-case
// instead, this uses word token boundaries to produce readable URL slugs and keys
// this implementation will not support Emoji or other non-ASCII characters

var kebabize = createCompounder(function (result, word, index) {
  return result + (index ? "-" : "") + word.toLowerCase();
});
function createCompounder(callback) {
  return function (str) {
    return words(str).reduce(callback, "");
  };
}
var words = function words(str) {
  str = str == null ? "" : str;
  return str.match(/([A-Z]{2,}|[0-9]+|[A-Z]?[a-z]+|[A-Z])/g) || [];
};

// Provide a standardized pipeline of checks and modifications to all operations based on provided options
// Currently skips execution if cancelled and implements an optional delay

var operate = function operate(operation, callback) {
  if (!operation.cancel) {
    operation.delay ? setTimeout(callback, operation.delay) : callback();
    return true;
  }
  return false;
};

// Dispatch life-cycle events with standardized naming
var before = function before(target, operation) {
  return dispatch(target, "cable-ready:before-".concat(kebabize(operation.operation)), operation);
};
var after = function after(target, operation) {
  return dispatch(target, "cable-ready:after-".concat(kebabize(operation.operation)), operation);
};
function debounce(fn) {
  var _this = this;
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var callback = function callback() {
      return fn.apply(_this, args);
    };
    if (timer) clearTimeout(timer);
    timer = setTimeout(callback, delay);
  };
}
function handleErrors(response) {
  if (!response.ok) throw Error(response.statusText);
  return response;
}
function safeScalar(val) {
  if (val !== undefined && !["string", "number", "boolean"].includes(_typeof(val))) console.warn("Operation expects a string, number or boolean, but got ".concat(val, " (").concat(_typeof(val), ")"));
  return val != null ? val : "";
}
function safeString(str) {
  if (str !== undefined && typeof str !== "string") console.warn("Operation expects a string, but got ".concat(str, " (").concat(_typeof(str), ")"));
  return str != null ? String(str) : "";
}
function safeArray(arr) {
  if (arr !== undefined && !Array.isArray(arr)) console.warn("Operation expects an array, but got ".concat(arr, " (").concat(_typeof(arr), ")"));
  return arr != null ? Array.from(arr) : [];
}
function safeObject(obj) {
  if (obj !== undefined && _typeof(obj) !== "object") console.warn("Operation expects an object, but got ".concat(obj, " (").concat(_typeof(obj), ")"));
  return obj != null ? Object(obj) : {};
}
function safeStringOrArray(elem) {
  if (elem !== undefined && !Array.isArray(elem) && typeof elem !== "string") console.warn("Operation expects an Array or a String, but got ".concat(elem, " (").concat(_typeof(elem), ")"));
  return elem == null ? "" : Array.isArray(elem) ? Array.from(elem) : String(elem);
}
function fragmentToString(fragment) {
  return new XMLSerializer().serializeToString(fragment);
}

// A proxy method to wrap a fetch call in error handling

// * url - the URL to fetch
// * additionalHeaders - an object of additional headers passed to fetch
function graciouslyFetch(_x, _x2) {
  return _graciouslyFetch.apply(this, arguments);
}
function _graciouslyFetch() {
  _graciouslyFetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(url, additionalHeaders) {
    var _response2;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return fetch(url, {
            headers: _objectSpread({
              "X-REQUESTED-WITH": "XmlHttpRequest"
            }, additionalHeaders)
          });
        case 3:
          _response2 = _context10.sent;
          if (!(_response2 == undefined)) {
            _context10.next = 6;
            break;
          }
          return _context10.abrupt("return");
        case 6:
          handleErrors(_response2);
          return _context10.abrupt("return", _response2);
        case 10:
          _context10.prev = 10;
          _context10.t0 = _context10["catch"](0);
          console.error("Could not fetch ".concat(url));
        case 13:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 10]]);
  }));
  return _graciouslyFetch.apply(this, arguments);
}
var BoundedQueue = /*#__PURE__*/function () {
  function BoundedQueue(maxSize) {
    _classCallCheck(this, BoundedQueue);
    this.maxSize = maxSize;
    this.queue = [];
  }
  _createClass(BoundedQueue, [{
    key: "push",
    value: function push(item) {
      if (this.isFull()) {
        // Remove the oldest item to make space for the new one
        this.shift();
      }
      this.queue.push(item);
    }
  }, {
    key: "shift",
    value: function shift() {
      return this.queue.shift();
    }
  }, {
    key: "isFull",
    value: function isFull() {
      return this.queue.length === this.maxSize;
    }
  }]);
  return BoundedQueue;
}();
var utils = Object.freeze({
  __proto__: null,
  BoundedQueue: BoundedQueue,
  after: after,
  assignFocus: assignFocus,
  before: before,
  debounce: debounce,
  dispatch: dispatch,
  fragmentToString: fragmentToString,
  getClassNames: getClassNames,
  graciouslyFetch: graciouslyFetch,
  handleErrors: handleErrors,
  isTextInput: isTextInput,
  kebabize: kebabize,
  operate: operate,
  processElements: processElements,
  safeArray: safeArray,
  safeObject: safeObject,
  safeScalar: safeScalar,
  safeString: safeString,
  safeStringOrArray: safeStringOrArray,
  xpathToElement: xpathToElement,
  xpathToElementArray: xpathToElementArray
});

// Indicates whether or not we should morph an element via onBeforeElUpdated callback
// SEE: https://github.com/patrick-steele-idem/morphdom#morphdomfromnode-tonode-options--node

var shouldMorph = function shouldMorph(operation) {
  return function (fromEl, toEl) {
    return !shouldMorphCallbacks.map(function (callback) {
      return typeof callback === "function" ? callback(operation, fromEl, toEl) : true;
    }).includes(false);
  };
}
// Execute any pluggable functions that modify elements after morphing via onElUpdated callback
;

var didMorph = function didMorph(operation) {
  return function (el) {
    didMorphCallbacks.forEach(function (callback) {
      if (typeof callback === "function") callback(operation, el);
    });
  };
};
var verifyNotMutable = function verifyNotMutable(detail, fromEl, toEl) {
  // Skip nodes that are equal:
  // https://github.com/patrick-steele-idem/morphdom#can-i-make-morphdom-blaze-through-the-dom-tree-even-faster-yes
  if (!mutableTags[fromEl.tagName] && fromEl.isEqualNode(toEl)) return false;
  return true;
};
var verifyNotContentEditable = function verifyNotContentEditable(detail, fromEl, toEl) {
  if (fromEl === ActiveElement.element && fromEl.isContentEditable) return false;
  return true;
};
var verifyNotPermanent = function verifyNotPermanent(detail, fromEl, toEl) {
  var permanentAttributeName = detail.permanentAttributeName;
  if (!permanentAttributeName) return true;
  var permanent = fromEl.closest("[".concat(permanentAttributeName, "]"));
  // only morph attributes on the active non-permanent text input
  if (!permanent && fromEl === ActiveElement.element && isTextInput(fromEl)) {
    var ignore = {
      value: true
    };
    Array.from(toEl.attributes).forEach(function (attribute) {
      if (!ignore[attribute.name]) fromEl.setAttribute(attribute.name, attribute.value);
    });
    return false;
  }
  return !permanent;
};
var shouldMorphCallbacks = [verifyNotMutable, verifyNotPermanent, verifyNotContentEditable];
var didMorphCallbacks = [];
var morph_callbacks = Object.freeze({
  __proto__: null,
  didMorph: didMorph,
  didMorphCallbacks: didMorphCallbacks,
  shouldMorph: shouldMorph,
  shouldMorphCallbacks: shouldMorphCallbacks,
  verifyNotContentEditable: verifyNotContentEditable,
  verifyNotMutable: verifyNotMutable,
  verifyNotPermanent: verifyNotPermanent
});
var Operations = {
  // DOM Mutations
  append: function append(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
          focusSelector = operation.focusSelector;
        element.insertAdjacentHTML("beforeend", safeScalar(html));
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  graft: function graft(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var parent = operation.parent,
          focusSelector = operation.focusSelector;
        var parentElement = document.querySelector(parent);
        if (parentElement) {
          parentElement.appendChild(element);
          assignFocus(focusSelector);
        }
      });
      after(element, operation);
    });
  },
  innerHtml: function innerHtml(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
          focusSelector = operation.focusSelector;
        element.innerHTML = safeScalar(html);
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  insertAdjacentHtml: function insertAdjacentHtml(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
          position = operation.position,
          focusSelector = operation.focusSelector;
        element.insertAdjacentHTML(position || "beforeend", safeScalar(html));
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  insertAdjacentText: function insertAdjacentText(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var text = operation.text,
          position = operation.position,
          focusSelector = operation.focusSelector;
        element.insertAdjacentText(position || "beforeend", safeScalar(text));
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  outerHtml: function outerHtml(operation) {
    processElements(operation, function (element) {
      var parent = element.parentElement;
      var idx = parent && Array.from(parent.children).indexOf(element);
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
          focusSelector = operation.focusSelector;
        element.outerHTML = safeScalar(html);
        assignFocus(focusSelector);
      });
      after(parent ? parent.children[idx] : document.documentElement, operation);
    });
  },
  prepend: function prepend(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
          focusSelector = operation.focusSelector;
        element.insertAdjacentHTML("afterbegin", safeScalar(html));
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  remove: function remove(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var focusSelector = operation.focusSelector;
        element.remove();
        assignFocus(focusSelector);
      });
      after(document, operation);
    });
  },
  replace: function replace(operation) {
    processElements(operation, function (element) {
      var parent = element.parentElement;
      var idx = parent && Array.from(parent.children).indexOf(element);
      before(element, operation);
      operate(operation, function () {
        var html = operation.html,
          focusSelector = operation.focusSelector;
        element.outerHTML = safeScalar(html);
        assignFocus(focusSelector);
      });
      after(parent ? parent.children[idx] : document.documentElement, operation);
    });
  },
  textContent: function textContent(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var text = operation.text,
          focusSelector = operation.focusSelector;
        element.textContent = safeScalar(text);
        assignFocus(focusSelector);
      });
      after(element, operation);
    });
  },
  // Element Property Mutations
  addCssClass: function addCssClass(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var _element$classList;
        var name = operation.name;
        (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(getClassNames([safeStringOrArray(name)])));
      });
      after(element, operation);
    });
  },
  removeAttribute: function removeAttribute(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name;
        element.removeAttribute(safeString(name));
      });
      after(element, operation);
    });
  },
  removeCssClass: function removeCssClass(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var _element$classList2;
        var name = operation.name;
        (_element$classList2 = element.classList).remove.apply(_element$classList2, _toConsumableArray(getClassNames([safeStringOrArray(name)])));
        if (element.classList.length === 0) element.removeAttribute("class");
      });
      after(element, operation);
    });
  },
  setAttribute: function setAttribute(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name,
          value = operation.value;
        element.setAttribute(safeString(name), safeScalar(value));
      });
      after(element, operation);
    });
  },
  setDatasetProperty: function setDatasetProperty(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name,
          value = operation.value;
        element.dataset[safeString(name)] = safeScalar(value);
      });
      after(element, operation);
    });
  },
  setProperty: function setProperty(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name,
          value = operation.value;
        if (name in element) element[safeString(name)] = safeScalar(value);
      });
      after(element, operation);
    });
  },
  setStyle: function setStyle(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name,
          value = operation.value;
        element.style[safeString(name)] = safeScalar(value);
      });
      after(element, operation);
    });
  },
  setStyles: function setStyles(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var styles = operation.styles;
        for (var _i = 0, _Object$entries = Object.entries(styles); _i < _Object$entries.length; _i++) {
          var _ref = _Object$entries[_i];
          var _ref2 = _slicedToArray(_ref, 2);
          var _name = _ref2[0];
          var value = _ref2[1];
          element.style[safeString(_name)] = safeScalar(value);
        }
      });
      after(element, operation);
    });
  },
  setValue: function setValue(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var value = operation.value;
        element.value = safeScalar(value);
      });
      after(element, operation);
    });
  },
  // DOM Events and Meta-Operations
  dispatchEvent: function dispatchEvent(operation) {
    processElements(operation, function (element) {
      before(element, operation);
      operate(operation, function () {
        var name = operation.name,
          detail = operation.detail;
        dispatch(element, safeString(name), safeObject(detail));
      });
      after(element, operation);
    });
  },
  setMeta: function setMeta(operation) {
    before(document, operation);
    operate(operation, function () {
      var name = operation.name,
        content = operation.content;
      var meta = document.head.querySelector("meta[name='".concat(name, "']"));
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = safeString(name);
        document.head.appendChild(meta);
      }
      meta.content = safeScalar(content);
    });
    after(document, operation);
  },
  setTitle: function setTitle(operation) {
    before(document, operation);
    operate(operation, function () {
      var title = operation.title;
      document.title = safeScalar(title);
    });
    after(document, operation);
  },
  // Browser Manipulations
  clearStorage: function clearStorage(operation) {
    before(document, operation);
    operate(operation, function () {
      var type = operation.type;
      var storage = type === "session" ? sessionStorage : localStorage;
      storage.clear();
    });
    after(document, operation);
  },
  go: function go(operation) {
    before(window, operation);
    operate(operation, function () {
      var delta = operation.delta;
      history.go(delta);
    });
    after(window, operation);
  },
  pushState: function pushState(operation) {
    before(window, operation);
    operate(operation, function () {
      var state = operation.state,
        title = operation.title,
        url = operation.url;
      history.pushState(safeObject(state), safeString(title), safeString(url));
    });
    after(window, operation);
  },
  redirectTo: function redirectTo(operation) {
    before(window, operation);
    operate(operation, function () {
      var url = operation.url,
        action = operation.action,
        turbo = operation.turbo;
      action = action || "advance";
      url = safeString(url);
      if (turbo === undefined) turbo = true;
      if (turbo) {
        if (window.Turbo) window.Turbo.visit(url, {
          action: action
        });
        if (window.Turbolinks) window.Turbolinks.visit(url, {
          action: action
        });
        if (!window.Turbo && !window.Turbolinks) window.location.href = url;
      } else {
        window.location.href = url;
      }
    });
    after(window, operation);
  },
  reload: function reload(operation) {
    before(window, operation);
    operate(operation, function () {
      window.location.reload();
    });
    after(window, operation);
  },
  removeStorageItem: function removeStorageItem(operation) {
    before(document, operation);
    operate(operation, function () {
      var key = operation.key,
        type = operation.type;
      var storage = type === "session" ? sessionStorage : localStorage;
      storage.removeItem(safeString(key));
    });
    after(document, operation);
  },
  replaceState: function replaceState(operation) {
    before(window, operation);
    operate(operation, function () {
      var state = operation.state,
        title = operation.title,
        url = operation.url;
      history.replaceState(safeObject(state), safeString(title), safeString(url));
    });
    after(window, operation);
  },
  scrollIntoView: function scrollIntoView(operation) {
    var element = operation.element;
    before(element, operation);
    operate(operation, function () {
      element.scrollIntoView(operation);
    });
    after(element, operation);
  },
  setCookie: function setCookie(operation) {
    before(document, operation);
    operate(operation, function () {
      var cookie = operation.cookie;
      document.cookie = safeScalar(cookie);
    });
    after(document, operation);
  },
  setFocus: function setFocus(operation) {
    var element = operation.element;
    before(element, operation);
    operate(operation, function () {
      assignFocus(element);
    });
    after(element, operation);
  },
  setStorageItem: function setStorageItem(operation) {
    before(document, operation);
    operate(operation, function () {
      var key = operation.key,
        value = operation.value,
        type = operation.type;
      var storage = type === "session" ? sessionStorage : localStorage;
      storage.setItem(safeString(key), safeScalar(value));
    });
    after(document, operation);
  },
  // Notifications
  consoleLog: function consoleLog(operation) {
    before(document, operation);
    operate(operation, function () {
      var message = operation.message,
        level = operation.level;
      level && ["warn", "info", "error"].includes(level) ? console[level](message) : console.log(message);
    });
    after(document, operation);
  },
  consoleTable: function consoleTable(operation) {
    before(document, operation);
    operate(operation, function () {
      var data = operation.data,
        columns = operation.columns;
      console.table(data, safeArray(columns));
    });
    after(document, operation);
  },
  notification: function notification(operation) {
    before(document, operation);
    operate(operation, function () {
      var title = operation.title,
        options = operation.options;
      Notification.requestPermission().then(function (result) {
        operation.permission = result;
        if (result === "granted") new Notification(safeString(title), safeObject(options));
      });
    });
    after(document, operation);
  },
  // Morph operations
  morph: function morph(operation) {
    processElements(operation, function (element) {
      var html = operation.html;
      var template = document.createElement("template");
      template.innerHTML = String(safeScalar(html)).trim();
      operation.content = template.content;
      var parent = element.parentElement;
      var idx = parent && Array.from(parent.children).indexOf(element);
      before(element, operation);
      operate(operation, function () {
        var childrenOnly = operation.childrenOnly,
          focusSelector = operation.focusSelector;
        morphdom(element, childrenOnly ? template.content : template.innerHTML, {
          childrenOnly: !!childrenOnly,
          onBeforeElUpdated: shouldMorph(operation),
          onElUpdated: didMorph(operation)
        });
        assignFocus(focusSelector);
      });
      after(parent ? parent.children[idx] : document.documentElement, operation);
    });
  }
};
var operations = Operations;
var add = function add(newOperations) {
  operations = _objectSpread(_objectSpread({}, operations), newOperations);
};
var addOperations = function addOperations(operations) {
  add(operations);
};
var addOperation = function addOperation(name, operation) {
  var operations = {};
  operations[name] = operation;
  add(operations);
};
var OperationStore = {
  get all() {
    return operations;
  }
};
var missingElement = "warn";
var MissingElement = {
  get behavior() {
    return missingElement;
  },
  set: function set(value) {
    if (["warn", "ignore", "event", "exception"].includes(value)) missingElement = value;else console.warn("Invalid 'onMissingElement' option. Defaulting to 'warn'.");
  }
};
var perform = function perform(operations) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    onMissingElement: MissingElement.behavior
  };
  var batches = {};
  operations.forEach(function (operation) {
    if (!!operation.batch) batches[operation.batch] = batches[operation.batch] ? ++batches[operation.batch] : 1;
  });
  operations.forEach(function (operation) {
    var name = operation.operation;
    try {
      if (operation.selector) {
        if (operation.xpath) {
          operation.element = operation.selectAll ? xpathToElementArray(operation.selector) : xpathToElement(operation.selector);
        } else {
          operation.element = operation.selectAll ? document.querySelectorAll(operation.selector) : document.querySelector(operation.selector);
        }
      } else {
        operation.element = document;
      }
      if (operation.element || options.onMissingElement !== "ignore") {
        ActiveElement.set(document.activeElement);
        var cableReadyOperation = OperationStore.all[name];
        if (cableReadyOperation) {
          cableReadyOperation(operation);
          if (!!operation.batch && --batches[operation.batch] === 0) dispatch(document, "cable-ready:batch-complete", {
            batch: operation.batch
          });
        } else {
          console.error("CableReady couldn't find the \"".concat(name, "\" operation. Make sure you use the camelized form when calling an operation method."));
        }
      }
    } catch (e) {
      if (operation.element) {
        console.error("CableReady detected an error in ".concat(name || "operation", ": ").concat(e.message, ". If you need to support older browsers make sure you've included the corresponding polyfills. https://docs.stimulusreflex.com/setup#polyfills-for-ie11."));
        console.error(e);
      } else {
        var warning = "CableReady ".concat(name || "", " operation failed due to missing DOM element for selector: '").concat(operation.selector, "'");
        switch (options.onMissingElement) {
          case "ignore":
            break;
          case "event":
            dispatch(document, "cable-ready:missing-element", {
              warning: warning,
              operation: operation
            });
            break;
          case "exception":
            throw warning;
          default:
            console.warn(warning);
        }
      }
    }
  });
};
var performAsync = function performAsync(operations) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    onMissingElement: MissingElement.behavior
  };
  return new Promise(function (resolve, reject) {
    try {
      resolve(perform(operations, options));
    } catch (err) {
      reject(err);
    }
  });
};
var SubscribingElement = /*#__PURE__*/function (_HTMLElement) {
  _inherits(SubscribingElement, _HTMLElement);
  var _super = _createSuper(SubscribingElement);
  function SubscribingElement() {
    _classCallCheck(this, SubscribingElement);
    return _super.apply(this, arguments);
  }
  _createClass(SubscribingElement, [{
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.channel) this.channel.unsubscribe();
    }
  }, {
    key: "createSubscription",
    value: function createSubscription(consumer, channel, receivedCallback) {
      this.channel = consumer.subscriptions.create({
        channel: channel,
        identifier: this.identifier
      }, {
        received: receivedCallback
      });
    }
  }, {
    key: "preview",
    get: function get() {
      return document.documentElement.hasAttribute("data-turbolinks-preview") || document.documentElement.hasAttribute("data-turbo-preview");
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.getAttribute("identifier");
    }
  }], [{
    key: "tagName",
    get: function get() {
      throw new Error("Implement the tagName() getter in the inheriting class");
    }
  }, {
    key: "define",
    value: function define() {
      if (!customElements.get(this.tagName)) {
        customElements.define(this.tagName, this);
      }
    }
  }]);
  return SubscribingElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
var consumer;
var BACKOFF = [25, 50, 75, 100, 200, 250, 500, 800, 1e3, 2e3];
var wait = function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var getConsumerWithRetry = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var retry,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          retry = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
          if (!consumer) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", consumer);
        case 3:
          if (!(retry >= BACKOFF.length)) {
            _context.next = 5;
            break;
          }
          throw new Error("Couldn't obtain a Action Cable consumer within 5s");
        case 5:
          _context.next = 7;
          return wait(BACKOFF[retry]);
        case 7:
          _context.next = 9;
          return getConsumerWithRetry(retry + 1);
        case 9:
          return _context.abrupt("return", _context.sent);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getConsumerWithRetry() {
    return _ref3.apply(this, arguments);
  };
}();
var CableConsumer = {
  setConsumer: function setConsumer(value) {
    consumer = value;
  },
  get consumer() {
    return consumer;
  },
  getConsumer: function getConsumer() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getConsumerWithRetry();
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};
var StreamFromElement = /*#__PURE__*/function (_SubscribingElement) {
  _inherits(StreamFromElement, _SubscribingElement);
  var _super2 = _createSuper(StreamFromElement);
  function StreamFromElement() {
    _classCallCheck(this, StreamFromElement);
    return _super2.apply(this, arguments);
  }
  _createClass(StreamFromElement, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var consumer;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.preview) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _context3.next = 4;
              return CableConsumer.getConsumer();
            case 4:
              consumer = _context3.sent;
              if (consumer) {
                this.createSubscription(consumer, "CableReady::Stream", this.performOperations.bind(this));
              } else {
                console.error("The `cable_ready_stream_from` helper cannot connect. You must initialize CableReady with an Action Cable consumer.");
              }
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "performOperations",
    value: function performOperations(data) {
      if (data.cableReady) perform(data.operations, {
        onMissingElement: this.onMissingElement
      });
    }
  }, {
    key: "onMissingElement",
    get: function get() {
      var value = this.getAttribute("missing") || MissingElement.behavior;
      // stream_from does not support raising exceptions on missing elements because there's no way to catch them
      if (["warn", "ignore", "event"].includes(value)) return value;else {
        console.warn("Invalid 'missing' attribute. Defaulting to 'warn'.");
        return "warn";
      }
    }
  }], [{
    key: "tagName",
    get: function get() {
      return "cable-ready-stream-from";
    }
  }]);
  return StreamFromElement;
}(SubscribingElement);
var debugging = false;
var Debug = {
  get enabled() {
    return debugging;
  },
  get disabled() {
    return !debugging;
  },
  get value() {
    return debugging;
  },
  set: function set(value) {
    debugging = !!value;
  },
  set debug(value) {
    debugging = !!value;
  }
};
var request = function request(data, blocks) {
  if (Debug.disabled) return;
  var message = "\u2191 Updatable request affecting ".concat(blocks.length, " element(s): ");
  console.log(message, {
    elements: blocks.map(function (b) {
      return b.element;
    }),
    identifiers: blocks.map(function (b) {
      return b.element.getAttribute("identifier");
    }),
    data: data
  });
  return message;
};
var cancel = function cancel(timestamp, reason) {
  if (Debug.disabled) return;
  var duration = new Date() - timestamp;
  var message = "\u274C Updatable request canceled after ".concat(duration, "ms: ").concat(reason);
  console.log(message);
  return message;
};
var response = function response(timestamp, element, urls) {
  if (Debug.disabled) return;
  var duration = new Date() - timestamp;
  var message = "\u2193 Updatable response: All URLs fetched in ".concat(duration, "ms");
  console.log(message, {
    element: element,
    urls: urls
  });
  return message;
};
var morphStart = function morphStart(timestamp, element) {
  if (Debug.disabled) return;
  var duration = new Date() - timestamp;
  var message = "\u21BB Updatable morph: starting after ".concat(duration, "ms");
  console.log(message, {
    element: element
  });
  return message;
};
var morphEnd = function morphEnd(timestamp, element) {
  if (Debug.disabled) return;
  var duration = new Date() - timestamp;
  var message = "\u21BA Updatable morph: completed after ".concat(duration, "ms");
  console.log(message, {
    element: element
  });
  return message;
};
var Log = {
  request: request,
  cancel: cancel,
  response: response,
  morphStart: morphStart,
  morphEnd: morphEnd
};
var AppearanceObserver = /*#__PURE__*/function () {
  function AppearanceObserver(delegate) {
    var _this2 = this;
    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, AppearanceObserver);
    this.observeVisibility = function () {
      document.addEventListener("visibilitychange", _this2.handleVisibilityChange);
    };
    this.unobserveVisibility = function () {
      document.removeEventListener("visibilitychange", _this2.handleVisibilityChange);
    };
    this.intersect = function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === _this2.element) {
          if (entry.isIntersecting && document.visibilityState === "visible") {
            _this2.intersecting = true;
            _this2.delegate.appearedInViewport();
          } else {
            _this2.intersecting = false;
            _this2.delegate.disappearedFromViewport();
          }
        }
      });
    };
    this.handleVisibilityChange = function (event) {
      if (document.visibilityState === "visible" && _this2.intersecting) {
        _this2.delegate.appearedInViewport();
      } else {
        _this2.delegate.disappearedFromViewport();
      }
    };
    this.delegate = delegate;
    this.element = element || delegate;
    this.started = false;
    this.intersecting = false;
    this.intersectionObserver = new IntersectionObserver(this.intersect);
  }
  _createClass(AppearanceObserver, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        this.started = true;
        this.intersectionObserver.observe(this.element);
        this.observeVisibility();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        this.started = false;
        this.intersectionObserver.unobserve(this.element);
        this.unobserveVisibility();
      }
    }
  }]);
  return AppearanceObserver;
}();
var template = "\n<style>\n  :host {\n    display: block;\n  }\n</style>\n<slot></slot>\n";
var UpdatesForElement = /*#__PURE__*/function (_SubscribingElement2) {
  _inherits(UpdatesForElement, _SubscribingElement2);
  var _super3 = _createSuper(UpdatesForElement);
  function UpdatesForElement() {
    var _this3;
    _classCallCheck(this, UpdatesForElement);
    _this3 = _super3.call(this);
    var shadowRoot = _this3.attachShadow({
      mode: "open"
    });
    shadowRoot.innerHTML = template;
    _this3.triggerElementLog = new BoundedQueue(10);
    _this3.targetElementLog = new BoundedQueue(10);
    _this3.appearanceObserver = new AppearanceObserver(_assertThisInitialized(_this3));
    _this3.visible = false;
    _this3.didTransitionToVisible = false;
    return _this3;
  }
  _createClass(UpdatesForElement, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var consumer;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.preview) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              this.update = debounce(this.update.bind(this), this.debounce);
              _context4.next = 5;
              return CableConsumer.getConsumer();
            case 5:
              consumer = _context4.sent;
              if (consumer) {
                this.createSubscription(consumer, "CableReady::Stream", this.update);
              } else {
                console.error("The `cable_ready_updates_for` helper cannot connect. You must initialize CableReady with an Action Cable consumer.");
              }
              if (this.observeAppearance) {
                this.appearanceObserver.start();
              }
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function connectedCallback() {
        return _connectedCallback2.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _get(_getPrototypeOf(UpdatesForElement.prototype), "disconnectedCallback", this).call(this);
      if (this.observeAppearance) {
        this.appearanceObserver.stop();
      }
    }
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(data) {
        var _this4 = this;
        var blocks, uniqueUrls;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.lastUpdateTimestamp = new Date();
              blocks = Array.from(document.querySelectorAll(this.query), function (element) {
                return new Block(element);
              }).filter(function (block) {
                return block.shouldUpdate(data);
              });
              this.triggerElementLog.push("".concat(new Date().toLocaleString(), ": ").concat(Log.request(data, blocks)));
              if (!(blocks.length === 0)) {
                _context6.next = 6;
                break;
              }
              this.triggerElementLog.push("".concat(new Date().toLocaleString(), ": ").concat(Log.cancel(this.lastUpdateTimestamp, "All elements filtered out")));
              return _context6.abrupt("return");
            case 6:
              if (!(blocks[0].element !== this && !this.didTransitionToVisible)) {
                _context6.next = 9;
                break;
              }
              this.triggerElementLog.push("".concat(new Date().toLocaleString(), ": ").concat(Log.cancel(this.lastUpdateTimestamp, "Update already requested")));
              return _context6.abrupt("return");
            case 9:
              // hold a reference to the active element so that it can be restored after the morph
              ActiveElement.set(document.activeElement);
              // store all retrieved HTML in an object keyed by URL to minimize fetch calls
              this.html = {};
              uniqueUrls = _toConsumableArray(new Set(blocks.map(function (block) {
                return block.url;
              })));
              _context6.next = 14;
              return Promise.all(uniqueUrls.map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(url) {
                  var _response;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (_this4.html.hasOwnProperty(url)) {
                          _context5.next = 7;
                          break;
                        }
                        _context5.next = 3;
                        return graciouslyFetch(url, {
                          "X-Cable-Ready": "update"
                        });
                      case 3:
                        _response = _context5.sent;
                        _context5.next = 6;
                        return _response.text();
                      case 6:
                        _this4.html[url] = _context5.sent;
                      case 7:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 14:
              this.triggerElementLog.push("".concat(new Date().toLocaleString(), ": ").concat(Log.response(this.lastUpdateTimestamp, this, uniqueUrls)));
              // track current block index for each URL; referred to as fragments
              this.index = {};
              blocks.forEach(function (block) {
                // if the block's URL is not in the index, initialize it to 0; otherwise, increment it
                _this4.index.hasOwnProperty(block.url) ? _this4.index[block.url]++ : _this4.index[block.url] = 0;
                block.process(data, _this4.html, _this4.index, _this4.lastUpdateTimestamp);
              });
            case 17:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function update(_x3) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
  }, {
    key: "appearedInViewport",
    value: function appearedInViewport() {
      if (!this.visible) {
        // transition from invisible to visible forces update
        this.didTransitionToVisible = true;
        this.update({});
      }
      this.visible = true;
    }
  }, {
    key: "disappearedFromViewport",
    value: function disappearedFromViewport() {
      this.visible = false;
    }
  }, {
    key: "query",
    get: function get() {
      return "".concat(this.tagName, "[identifier=\"").concat(this.identifier, "\"]");
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.getAttribute("identifier");
    }
  }, {
    key: "debounce",
    get: function get() {
      return this.hasAttribute("debounce") ? parseInt(this.getAttribute("debounce")) : 20;
    }
  }, {
    key: "observeAppearance",
    get: function get() {
      return this.hasAttribute("observe-appearance");
    }
  }], [{
    key: "tagName",
    get: function get() {
      return "cable-ready-updates-for";
    }
  }]);
  return UpdatesForElement;
}(SubscribingElement);
var Block = /*#__PURE__*/function () {
  function Block(element) {
    _classCallCheck(this, Block);
    this.element = element;
  }
  _createClass(Block, [{
    key: "process",
    value: function () {
      var _process = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(data, html, fragmentsIndex, startTimestamp) {
        var _this5 = this;
        var blockIndex, template, fragments, operation;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              blockIndex = fragmentsIndex[this.url];
              template = document.createElement("template");
              this.element.setAttribute("updating", "updating");
              template.innerHTML = String(html[this.url]).trim();
              _context7.next = 6;
              return this.resolveTurboFrames(template.content);
            case 6:
              fragments = template.content.querySelectorAll(this.query);
              if (!(fragments.length <= blockIndex)) {
                _context7.next = 10;
                break;
              }
              console.warn("Update aborted due to insufficient number of elements. The offending url is ".concat(this.url, ", the offending element is:"), this.element);
              return _context7.abrupt("return");
            case 10:
              operation = {
                element: this.element,
                html: fragments[blockIndex],
                permanentAttributeName: "data-ignore-updates"
              };
              dispatch(this.element, "cable-ready:before-update", operation);
              this.element.targetElementLog.push("".concat(new Date().toLocaleString(), ": ").concat(Log.morphStart(startTimestamp, this.element)));
              morphdom(this.element, fragments[blockIndex], {
                childrenOnly: true,
                onBeforeElUpdated: shouldMorph(operation),
                onElUpdated: function onElUpdated(_) {
                  _this5.element.removeAttribute("updating");
                  _this5.element.didTransitionToVisible = false;
                  dispatch(_this5.element, "cable-ready:after-update", operation);
                  assignFocus(operation.focusSelector);
                }
              });
              this.element.targetElementLog.push("".concat(new Date().toLocaleString(), ": ").concat(Log.morphEnd(startTimestamp, this.element)));
            case 15:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function process(_x5, _x6, _x7, _x8) {
        return _process.apply(this, arguments);
      }
      return process;
    }()
  }, {
    key: "resolveTurboFrames",
    value: function () {
      var _resolveTurboFrames = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(documentFragment) {
        var _this6 = this;
        var reloadingTurboFrames;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              reloadingTurboFrames = _toConsumableArray(documentFragment.querySelectorAll('turbo-frame[src]:not([loading="lazy"])'));
              return _context9.abrupt("return", Promise.all(reloadingTurboFrames.map(function (frame) {
                return new Promise( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(resolve) {
                    var frameResponse, frameTemplate, selector, frameContent, content;
                    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                      while (1) switch (_context8.prev = _context8.next) {
                        case 0:
                          _context8.next = 2;
                          return graciouslyFetch(frame.getAttribute("src"), {
                            "Turbo-Frame": frame.id,
                            "X-Cable-Ready": "update"
                          });
                        case 2:
                          frameResponse = _context8.sent;
                          frameTemplate = document.createElement("template");
                          _context8.next = 6;
                          return frameResponse.text();
                        case 6:
                          frameTemplate.innerHTML = _context8.sent;
                          _context8.next = 9;
                          return _this6.resolveTurboFrames(frameTemplate.content);
                        case 9:
                          selector = "turbo-frame#".concat(frame.id);
                          frameContent = frameTemplate.content.querySelector(selector);
                          content = frameContent ? frameContent.innerHTML.trim() : "";
                          documentFragment.querySelector(selector).innerHTML = content;
                          resolve();
                        case 14:
                        case "end":
                          return _context8.stop();
                      }
                    }, _callee8);
                  }));
                  return function (_x10) {
                    return _ref5.apply(this, arguments);
                  };
                }());
              })));
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function resolveTurboFrames(_x9) {
        return _resolveTurboFrames.apply(this, arguments);
      }
      return resolveTurboFrames;
    }()
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(data) {
      // if everything that could prevent an update is false, update this block
      return !this.ignoresInnerUpdates && this.hasChangesSelectedForUpdate(data) && (!this.observeAppearance || this.visible);
    }
  }, {
    key: "hasChangesSelectedForUpdate",
    value: function hasChangesSelectedForUpdate(data) {
      // if there's an only attribute, only update if at least one of the attributes changed is in the allow list
      var only = this.element.getAttribute("only");
      return !(only && data.changed && !only.split(" ").some(function (attribute) {
        return data.changed.includes(attribute);
      }));
    }
  }, {
    key: "ignoresInnerUpdates",
    get: function get() {
      // don't update during a Reflex or Turbolinks redraw
      return this.element.hasAttribute("ignore-inner-updates") && this.element.hasAttribute("performing-inner-update");
    }
  }, {
    key: "url",
    get: function get() {
      return this.element.hasAttribute("url") ? this.element.getAttribute("url") : location.href;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.element.identifier;
    }
  }, {
    key: "query",
    get: function get() {
      return this.element.query;
    }
  }, {
    key: "visible",
    get: function get() {
      return this.element.visible;
    }
  }, {
    key: "observeAppearance",
    get: function get() {
      return this.element.observeAppearance;
    }
  }]);
  return Block;
}();
var registerInnerUpdates = function registerInnerUpdates() {
  document.addEventListener("stimulus-reflex:before", function (event) {
    recursiveMarkUpdatesForElements(event.detail.element);
  });
  document.addEventListener("stimulus-reflex:after", function (event) {
    setTimeout(function () {
      recursiveUnmarkUpdatesForElements(event.detail.element);
    });
  });
  document.addEventListener("turbo:submit-start", function (event) {
    recursiveMarkUpdatesForElements(event.target);
  });
  document.addEventListener("turbo:submit-end", function (event) {
    setTimeout(function () {
      recursiveUnmarkUpdatesForElements(event.target);
    });
  });
  document.addEventListener("turbo-boost:command:start", function (event) {
    recursiveMarkUpdatesForElements(event.target);
  });
  document.addEventListener("turbo-boost:command:finish", function (event) {
    setTimeout(function () {
      recursiveUnmarkUpdatesForElements(event.target);
    });
  });
  document.addEventListener("turbo-boost:command:error", function (event) {
    setTimeout(function () {
      recursiveUnmarkUpdatesForElements(event.target);
    });
  });
};
var recursiveMarkUpdatesForElements = function recursiveMarkUpdatesForElements(leaf) {
  var closestUpdatesFor = leaf && leaf.parentElement && leaf.parentElement.closest("cable-ready-updates-for");
  if (closestUpdatesFor) {
    closestUpdatesFor.setAttribute("performing-inner-update", "");
    recursiveMarkUpdatesForElements(closestUpdatesFor);
  }
};
var recursiveUnmarkUpdatesForElements = function recursiveUnmarkUpdatesForElements(leaf) {
  var closestUpdatesFor = leaf && leaf.parentElement && leaf.parentElement.closest("cable-ready-updates-for");
  if (closestUpdatesFor) {
    closestUpdatesFor.removeAttribute("performing-inner-update");
    recursiveUnmarkUpdatesForElements(closestUpdatesFor);
  }
};
var defineElements = function defineElements() {
  registerInnerUpdates();
  StreamFromElement.define();
  UpdatesForElement.define();
};
var initialize = function initialize() {
  var initializeOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var consumer = initializeOptions.consumer,
    onMissingElement = initializeOptions.onMissingElement,
    debug = initializeOptions.debug;
  Debug.set(!!debug);
  if (consumer) {
    CableConsumer.setConsumer(consumer);
  } else {
    console.error("CableReady requires a reference to your Action Cable `consumer` for its helpers to function.\nEnsure that you have imported the `CableReady` package as well as `consumer` from your `channels` folder, then call `CableReady.initialize({ consumer })`.");
  }
  if (onMissingElement) {
    MissingElement.set(onMissingElement);
  }
  defineElements();
};
var global = {
  perform: perform,
  performAsync: performAsync,
  shouldMorphCallbacks: shouldMorphCallbacks,
  didMorphCallbacks: didMorphCallbacks,
  initialize: initialize,
  addOperation: addOperation,
  addOperations: addOperations,
  version: packageInfo.version,
  cable: CableConsumer,
  get DOMOperations() {
    console.warn("DEPRECATED: Please use `CableReady.operations` instead of `CableReady.DOMOperations`");
    return OperationStore.all;
  },
  get operations() {
    return OperationStore.all;
  },
  get consumer() {
    return CableConsumer.consumer;
  }
};
window.CableReady = global;
export { morph_callbacks as MorphCallbacks, StreamFromElement, SubscribingElement, UpdatesForElement, utils as Utils, global as default };